<template>
    <div>
        <div class="music">
            <div v-if="showFlag !== 3" class="bg-music" @click="tapMusic" :class="bgMusicShow?'music-on':'music-off'"></div>
            <audio autoplay preload="auto" loop="loop" ref="bgMusic" class="bg-music">
                <source src="./assets/audio/bg.mp3">
            </audio>
        </div>
        <start @next="next" v-if="showFlag === 1"></start>
        <test @next="next" v-if="showFlag === 2"></test>
        <testResult @next="next" v-if="showFlag === 3"></testResult>
    </div>
</template>

<script>
import '@page/summerprize/assets/css/common.styl';
import summerprizeModule from '@page/summerprize/store';
import wxShare from '@utils/wxShare';
import start from './componets/start';
import test from './componets/test';
import testResult from './componets/testResult';

export default {
    components: {
        start,
        test,
        testResult
    },
    data() {
        return {
            showFlag: 1,
            bgMusicShow: true
        };
    },
    mounted() {
        if (/* eslint-disable*/!this.$store._modules.root._children.summerprize /* eslint-enable */) {
            this.$store.registerModule('summerprize', summerprizeModule);
        }
        wxShare({
            title: '测测你在古代夏天能坚持多久？',
            desc: '这天实在太热了，我受不了了',
            link: `${location.origin}/summerprize`,
            imgUrl: 'http://wwj.jijiagames.com/web/act/20190702/rabbit_share.jpg'
        }, () => {
            this.$refs.bgMusic.play();
        });
        // 分渠道
        switch (this.$route.params.source) {
            case 'tuiguang1 ':
                if (this.$route.query.falg) {
                    /* eslint-disable-next-line */
                    window._hmt.push(['_trackEvent', '市场夏日抽奖活动-跳转微店', '市场tuiguang1渠道扫码进入数量量 ', window.location.href]);  // 百度埋点
                }
                break;
            case 'tuiguang2':
                if (this.$route.query.falg) {
                    /* eslint-disable-next-line */
                    window._hmt.push(['_trackEvent', '市场夏日抽奖活动-跳转微店', '市场tuiguang2渠道扫码进入数量量 ', window.location.href]);
                }
                break;
            default:
                if (this.$route.query.falg) {
                    /* eslint-disable-next-line */
                    window._hmt.push(['_trackEvent', '市场夏日抽奖活动-跳转微店', '市场default渠道扫码进入数量量 ', window.location.href]);
                }
                break;
        }
    },
    methods: {
        tapMusic() {
            this.bgMusicShow = !this.bgMusicShow;
            if (this.bgMusicShow) {
                this.$refs.bgMusic.play();
                this.chooseMusic = true;
            }
            else {
                this.$refs.bgMusic.pause();
                this.chooseMusic = false;
            }
        },
        next(value) {
            this.showFlag = value;
        }
    }
};
</script>

<style lang="stylus" scoped>
.music, .bg-music
    position fixed
    width 0.67rem
    height 0.67rem
    top 0.2rem
    right 0.3rem
    z-index 999
.music-on
    background url('./assets/img/music_on.png') no-repeat
    z-index 999
.music-off
    background url('./assets/img/music_off.png') no-repeat
    z-index 999
</style>
